/**
 * @returns {import("~/config/useGetRichtTextValues").RichTextValuesLocales}
 */
export const freManualRichtTextValues = {
  'de-DE': {
    contactEmail: 'karriere@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/de-DE/job-suche',
    disclaimerUrl: '/de-DE/datenschutz',
  },
  'en-US': {
    contactEmail: 'careers@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/job-search',
    disclaimerUrl: '/data-protection',
    privacyPolicyUrl: '/privacy-policy',
  },
};
